import { api } from './api';

class CrawlingService {
  // Existing methods from the original service...
  
  // Crawl Tasks endpoints
  async getCrawlTasks(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await api.get(`/api/crawling/tasks/?${queryParams}`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async createCrawlTask(taskData) {
    try {
      const response = await api.post('/api/crawling/tasks/', taskData);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  // NEW: Recrawling methods
  async recrawlPlace(placeId) {
    try {
      const response = await api.post(`/api/crawling/places/${placeId}/recrawl/`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async getCrawlStatus(placeId) {
    try {
      const response = await api.get(`/api/crawling/places/${placeId}/crawl-status/`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async startBatchRecrawl(batchData) {
    try {
      const response = await api.post('/api/crawling/batch-recrawl/', batchData);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async getBatchCrawlStatus(placeIds) {
    try {
      const response = await api.post('/api/crawling/batch-crawl-status/', {
        place_ids: placeIds
      });
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  // Existing methods continue...
  async getCrawlTaskDetail(taskId) {
    try {
      const response = await api.get(`/api/crawling/tasks/${taskId}/`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async updateCrawlTask(taskId, updateData) {
    try {
      const response = await api.patch(`/api/crawling/tasks/${taskId}/`, updateData);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async deleteCrawlTask(taskId) {
    try {
      const response = await api.delete(`/api/crawling/tasks/${taskId}/`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async cancelCrawlTask(taskId) {
    try {
      const response = await api.patch(`/api/crawling/tasks/${taskId}/`, {
        status: 'cancelled'
      });
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async getBulkCrawlStatus(placeIds) {
  try {
    const response = await api.post('/api/crawling/places/bulk-crawl-status/', {
      place_ids: placeIds
    });
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || error.message };
  }
}

  // Social Media Links endpoints
  async getSocialMediaLinks(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await api.get(`/api/crawling/links/?${queryParams}`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async getSocialMediaLinkDetail(linkId) {
    try {
      const response = await api.get(`/api/crawling/links/${linkId}/`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async updateSocialMediaLink(linkId, updateData) {
    try {
      const response = await api.patch(`/api/crawling/links/${linkId}/`, updateData);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async deleteSocialMediaLink(linkId) {
    try {
      const response = await api.delete(`/api/crawling/links/${linkId}/`);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async deleteSocialMediaLinks(linkIds) {
    try {
      const response = await api.delete('/api/crawling/links/', {
        data: { link_ids: linkIds }
      });
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  // Batch operations
  async startBatchCrawl(placeIds) {
    try {
      const response = await api.post('/api/crawling/batch-crawl/', {
        place_ids: placeIds
      });
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async verifyLinks(crawlTaskId) {
    try {
      const response = await api.post('/api/crawling/verify-links/', {
        crawl_task_id: crawlTaskId
      });
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  // Social Media Platforms
  async getSocialMediaPlatforms() {
    try {
      const response = await api.get('/api/crawling/platforms/');
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  // Statistics
  async getCrawlStats() {
    try {
      const response = await api.get('/api/crawling/stats/');
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async getDomainStats() {
    try {
      const response = await api.get('/api/crawling/domain-stats/');
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  // Configuration (admin only)
  async getCrawlConfiguration() {
    try {
      const response = await api.get('/api/crawling/config/');
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  async updateCrawlConfiguration(configData) {
    try {
      const response = await api.patch('/api/crawling/config/', configData);
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

  // Health check
  async healthCheck() {
    try {
      const response = await api.get('/api/crawling/health/');
      return { data: response.data, error: null };
    } catch (error) {
      return { data: null, error: error.response?.data || error.message };
    }
  }

    async getBatchSocialMediaLinks(placeIds) {
    try {
      const promises = placeIds.map(placeId => 
        this.getSocialMediaLinks({ place_id: placeId, page_size: 50 })
      );
      
      const results = await Promise.all(promises);
      const linksByPlace = {};
      
      results.forEach((result, index) => {
        const placeId = placeIds[index];
        if (result.data && result.data.results) {
          linksByPlace[placeId] = result.data.results;
        } else {
          linksByPlace[placeId] = [];
        }
      });
      
      return { data: linksByPlace, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  }
    async getSocialLinksSummary(placeIds) {
    try {
      const promises = placeIds.map(placeId => 
        this.getSocialMediaLinks({ 
          place_id: placeId, 
          page_size: 10, // Just get top links
          verification_status: 'verified' // Prioritize verified links
        })
      );
      
      const results = await Promise.all(promises);
      const summaryByPlace = {};
      
      results.forEach((result, index) => {
        const placeId = placeIds[index];
        if (result.data && result.data.results) {
          const links = result.data.results;
          summaryByPlace[placeId] = {
            totalLinks: result.data.count || 0,
            verifiedLinks: links.filter(l => l.verification_status === 'verified').length,
            platforms: [...new Set(links.map(l => l.link_type))],
            topLinks: links.slice(0, 4),
            hasEmail: links.some(l => l.link_type === 'email'),
            hasPhone: links.some(l => l.link_type === 'phone'),
            hasSocial: links.some(l => ['facebook', 'instagram', 'twitter', 'linkedin', 'youtube', 'tiktok'].includes(l.link_type))
          };
        } else {
          summaryByPlace[placeId] = {
            totalLinks: 0,
            verifiedLinks: 0,
            platforms: [],
            topLinks: [],
            hasEmail: false,
            hasPhone: false,
            hasSocial: false
          };
        }
      });
      
      return { data: summaryByPlace, error: null };
    } catch (error) {
      return { data: null, error: error.message };
    }
  }

  // Utility methods
  getStatusColor(status) {
    const statusColors = {
      pending: 'bg-yellow-100 text-yellow-800',
      processing: 'bg-blue-100 text-blue-800',
      completed: 'bg-green-100 text-green-800',
      failed: 'bg-red-100 text-red-800',
      retrying: 'bg-orange-100 text-orange-800',
      cancelled: 'bg-gray-100 text-gray-800',
    };
    return statusColors[status] || 'bg-gray-100 text-gray-800';
  }

  getStatusIcon(status) {
    const statusIcons = {
      pending: '⏳',
      processing: '🔄',
      completed: '✅',
      failed: '❌',
      retrying: '🔁',
      cancelled: '⚪',
    };
    return statusIcons[status] || '❓';
  }

  getPlatformIcon(platform) {
    const platformIcons = {
      facebook: '📘',
      instagram: '📷',
      twitter: '🐦',
      linkedin: '💼',
      youtube: '🎥',
      tiktok: '🎵',
      whatsapp: '📱',
      email: '📧',
      phone: '📞',
      website: '🌐',
      other: '🔗',
    };
    return platformIcons[platform] || '🔗';
  }

  getPlatformColor(platform) {
    const platformColors = {
      facebook: '#1877F2',
      instagram: '#E4405F',
      twitter: '#1DA1F2',
      linkedin: '#0A66C2',
      youtube: '#FF0000',
      tiktok: '#000000',
      whatsapp: '#25D366',
      email: '#6B7280',
      phone: '#6B7280',
      website: '#6B7280',
      other: '#6B7280',
    };
    return platformColors[platform] || '#6B7280';
  }

  formatDuration(seconds) {
    if (!seconds) return 'N/A';
    
    if (seconds < 60) {
      return `${seconds.toFixed(1)}s`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes}m ${remainingSeconds}s`;
    } else {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return `${hours}h ${minutes}m`;
    }
  }

  formatTimestamp(timestamp) {
    if (!timestamp) return 'N/A';
    
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 1) {
      return 'Just now';
    } else if (diffMins < 60) {
      return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    } else if (diffDays < 7) {
      return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    } else {
      return date.toLocaleDateString();
    }
  }

  getVerificationStatusColor(status) {
    const statusColors = {
      unverified: 'bg-gray-100 text-gray-800',
      verified: 'bg-green-100 text-green-800',
      broken: 'bg-red-100 text-red-800',
      redirected: 'bg-yellow-100 text-yellow-800',
    };
    return statusColors[status] || 'bg-gray-100 text-gray-800';
  }

  getVerificationStatusIcon(status) {
    const statusIcons = {
      unverified: '❓',
      verified: '✅',
      broken: '❌',
      redirected: '🔀',
    };
    return statusIcons[status] || '❓';
  }
}


export const crawlingService = new CrawlingService();
export default CrawlingService;